import { useAdmin, usePermissions } from '@/utils/hooks'
import { PERMISSIONS } from '@/utils/permissions'
import { useSalaryModuleConfiguration } from './hooks/useSalaryModuleConfiguration'

interface ApprovableWorkPeriod {
  user: { id: string }
  approvedByUser: boolean
  userComment: string
  approvedByManager: boolean
  managerComment: string
}

export const useWorkPeriodApprovePermissions = () => {
  const { hasPermissions } = usePermissions()
  const admin = useAdmin()
  const salaryModuleConfiguration = useSalaryModuleConfiguration()
  const canConfirmOthers = hasPermissions(
    [
      PERMISSIONS.workPeriod.view.othersworkperiod,
      PERMISSIONS.workPeriod.approve.workperiod,
      PERMISSIONS.workPeriod.change.workperiod,
    ],
    true
  )

  function workPeriodApprovalState(
    meId: string,
    workPeriod: ApprovableWorkPeriod
  ) {
    const isManager =
      meId !== workPeriod.user.id && (canConfirmOthers || admin)
    const driverApproveDirty =
      workPeriod.approvedByUser || workPeriod.userComment
    const managerApproveDirty =
      workPeriod.approvedByManager || workPeriod.managerComment

    const canApproveAsDriver =
      (meId === workPeriod.user.id || admin) &&
      !(
        workPeriod.approvedByManager ||
        !salaryModuleConfiguration.managerApprove
      )
    const canApproveAsManager =
      isManager &&
      (workPeriod.approvedByUser ||
        !salaryModuleConfiguration.driverApprove ||
        admin)

    return {
      driverApproveDirty,
      managerApproveDirty,
      canApproveAsDriver,
      canApproveAsManager,
    }
  }

  return { canConfirmOthers, workPeriodApprovalState }
}
